// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-panel-container {
  height: 100%;
  width: 0%;
  min-width: 0px;
  z-index: 2;
  pointer-events: auto;
  border: none;
  transition: all 0.5s ease-out;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: var(--dialog-background-color);

  --side-panel-padding: calc(var(--dialog-padding) / 2);
}

.side-panel-container-visible {
  min-width: var(--side-panel-min-width);
  overflow: unset;
}

.side-panel-header,
.side-panel-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--side-panel-padding);
  padding: var(--side-panel-padding);
  font-size: var(--font-size-l);
  max-width: 100%;
}

.side-panel-header {
  border-bottom: 1px solid var(--border-color);
}

.side-panel-footer {
  border-top: 1px solid var(--border-color);
}

.side-panel-header-divider {
  height: 100%;
  width: 1px;
  background-color: var(--border-color);
}

.side-panel-header-spacer {
  flex-grow: 1;
}

.side-panel-header-tab {
  color: var(--text-color-inactive);
  border-radius: var(--dialog-border-radius);
  padding: 0 var(--input-element-gap);
  transition: background-color 0.3s, color 0.3s;
}

.side-panel-header-tab:hover {
  background-color: var(--extra-light-grey);
  color: var(--text-color);
  cursor: pointer;
}

.side-panel-header-tab-selected {
  color: var(--text-color);
  text-decoration: underline;
}

.side-panel-second-header h2 {
  margin: calc(0px - (var(--side-panel-padding) / 2)) auto;
  font-size: var(--font-size-xl);
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/session-view/side-panels/side-panels.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,SAAS;EACT,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gDAAgD;;EAEhD,qDAAqD;AACvD;;AAEA;EACE,sCAAsC;EACtC,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,wDAAwD;EACxD,8BAA8B;AAChC","sourcesContent":[".side-panel-container {\n  height: 100%;\n  width: 0%;\n  min-width: 0px;\n  z-index: 2;\n  pointer-events: auto;\n  border: none;\n  transition: all 0.5s ease-out;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--dialog-background-color);\n\n  --side-panel-padding: calc(var(--dialog-padding) / 2);\n}\n\n.side-panel-container-visible {\n  min-width: var(--side-panel-min-width);\n  overflow: unset;\n}\n\n.side-panel-header,\n.side-panel-footer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--side-panel-padding);\n  padding: var(--side-panel-padding);\n  font-size: var(--font-size-l);\n  max-width: 100%;\n}\n\n.side-panel-header {\n  border-bottom: 1px solid var(--border-color);\n}\n\n.side-panel-footer {\n  border-top: 1px solid var(--border-color);\n}\n\n.side-panel-header-divider {\n  height: 100%;\n  width: 1px;\n  background-color: var(--border-color);\n}\n\n.side-panel-header-spacer {\n  flex-grow: 1;\n}\n\n.side-panel-header-tab {\n  color: var(--text-color-inactive);\n  border-radius: var(--dialog-border-radius);\n  padding: 0 var(--input-element-gap);\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.side-panel-header-tab:hover {\n  background-color: var(--extra-light-grey);\n  color: var(--text-color);\n  cursor: pointer;\n}\n\n.side-panel-header-tab-selected {\n  color: var(--text-color);\n  text-decoration: underline;\n}\n\n.side-panel-second-header h2 {\n  margin: calc(0px - (var(--side-panel-padding) / 2)) auto;\n  font-size: var(--font-size-xl);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
